import URI from 'urijs';
import _ from 'underscore';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { getRoutePathById } from '@bingads-webui-react/with-site-map';
import { AccountPausedWarningType, IOExhaustingWarningType, IOExpiringWarningType, LogsScenario } from '../src/constants';

export const navigateToIOPage = ({
  uid, cid, aid, iofilter, history, siteMap,
}) => {
  const siteMapId = 'insertionOrder';
  const path = getRoutePathById(siteMap, siteMapId);
  const uri = new URI(path);
  uri.addSearch({
    uid,
    cid,
    aid: aid || '',
    iofilter: iofilter || '',
    entrypoint: Constants.IOEntryPointAlias.IONotificationsEnhancement,
  });
  history.push({ pathname: uri.path(), search: uri.search() });
};

export const getAccountIOWarningProps = ({
  warnings,
}) => {
  const isIOExpiring = _.some(warnings, w => w.NotificationTypeId === Constants.NotificationType.InsertionOrderExpiringUrgentEvent);
  const isIOExhausting = _.some(warnings, w => w.NotificationTypeId === Constants.NotificationType.InsertionOrderExhaustingUrgentEvent);
  return { isIOExpiring, isIOExhausting };
};

export const getCustomerIOWarningProps = ({
  warnings,
}) => {
  let numOfIOBalanceDepleted = 0;
  let numOfIOExpired = 0;
  let numOfIOExpiring = 0;
  let numOfIOExhausting = 0;
  _.each(warnings, (warning) => {
    const notificationCount = warning.NotificationCount || 1;
    switch (warning.NotificationTypeId) {
      /*
        In the data from CCMT,
        for a customer, if more than 1 account under the customer
        have same type notification, MT will return {... NotificationCount: 3 ...}.
        But if only one account has this type notification,
        NotificationCount won't be included in the data.
        So I use `|| 1` here to avoid undefined.
      */
      case Constants.NotificationType.InsertionOrderBalanceDepletedEvent:
        numOfIOBalanceDepleted = notificationCount;
        break;
      case Constants.NotificationType.InsertionOrderExpiredEvent:
        numOfIOExpired = notificationCount;
        break;
      case Constants.NotificationType.InsertionOrderExpiringUrgentEvent:
        numOfIOExpiring = notificationCount;
        break;
      case Constants.NotificationType.InsertionOrderExhaustingUrgentEvent:
        numOfIOExhausting = notificationCount;
        break;
      default:
        break;
    }
  });
  return {
    numOfAccountPaused: numOfIOBalanceDepleted + numOfIOExpired,
    numOfIOExhausting,
    numOfIOExpiring,
  };
};

export const getDismissWarningsInfo = ({ warnings, warningsTypeIdsToDismiss }) => {
  const uiDeliveryIds = [];
  const notificationTypeIds = [];
  const ids = [];
  _.each(warnings, (warning) => {
    if (warningsTypeIdsToDismiss.indexOf(warning.NotificationTypeId) !== -1) {
      if (warning.UIDeliveryId) {
        uiDeliveryIds.push(warning.UIDeliveryId);
      } else {
        notificationTypeIds.push(warning.NotificationTypeId);
      }
      ids.push(warning.id);
    }
  });
  return { ids, notificationTypeIds, uiDeliveryIds };
};

export const getWarningsLogInfo = ({
  aid, warningsTypeIds, uiDeliveryIds, isDismiss,
}) => {
  let scenarioName;
  const message = {
    warningTypes: warningsTypeIds,
    warningIds: uiDeliveryIds,
  };
  switch (warningsTypeIds) {
    case AccountPausedWarningType:
      scenarioName = isDismiss ? LogsScenario.AccountPausedWarningDismiss : LogsScenario.AccountPausedWarningJump;
      break;
    case IOExpiringWarningType:
      if (isDismiss) {
        scenarioName = aid > 0 ? LogsScenario.AccountExpiringWarningDismiss : LogsScenario.CustomerExpiringWarningDismiss;
      } else {
        scenarioName = aid > 0 ? LogsScenario.AccountExpiringWarningJump : LogsScenario.CustomerExpiringWarningJump;
      }
      break;
    case IOExhaustingWarningType:
      if (isDismiss) {
        scenarioName = aid > 0 ? LogsScenario.AccountExhaustingWarningDismiss : LogsScenario.CustomerExhaustingWarningDismiss;
      } else {
        scenarioName = aid > 0 ? LogsScenario.AccountExhaustingWarningJump : LogsScenario.CustomerExhaustingWarningJump;
      }
      break;
    default:
      return {};
  }
  return { scenarioName, message };
};

export const logActionInfos = ({
  recommendationIds, warningsTypeIds, uiDeliveryIds, aid, logger, isDismiss,
}) => {
  let logInfo;
  if (!_.isEmpty(recommendationIds)) {
    logInfo = {
      scenarioName: isDismiss ? LogsScenario.RecommendationDismiss : LogsScenario.RecommendationJump,
      message: {
        recommendationIds,
      },
    };
  } else if (!_.isEmpty(warningsTypeIds)) {
    logInfo = getWarningsLogInfo({
      aid, warningsTypeIds, uiDeliveryIds, isDismiss,
    });
  }
  if (logInfo && !(_.isEmpty(logInfo.scenarioName) || _.isEmpty(logInfo.message))) {
    logger.trace(logInfo);
  }
};
